<script lang="ts">
  import AtIcon from '$icons/AtIcon.svelte';
  import { client } from '$lib/api/Client';
  import { UsernameValidationCode } from '$utils/interfaces/users';
  import TextInput from './TextInput.svelte';
  import { usernameSchema } from '$shared/lib';

  export let value = '';
  export let description = '';
  export let placeholder = '';
  export let errors: string[] = [];
  export let required = false;

  let searchTimeout: NodeJS.Timeout;
  const validateUsername = async () => {
    clearTimeout(searchTimeout);
    if (value.length > 0) {
      searchTimeout = setTimeout(async () => {
        const zodResult = usernameSchema.safeParse(value);
        if (!zodResult.success) return;

        const validation = await client.users.usernameValidation(value);
        errors = validation.code === UsernameValidationCode.UNAVAILABLE ? [validation.message] : [];
      }, 400);
    } else {
      errors = [];
    }
  };
</script>

<TextInput
  label="Username"
  {placeholder}
  {description}
  {required}
  bind:value
  bind:errors
  on:keyup={validateUsername}
>
  <div slot="left-icon">
    <AtIcon />
  </div>
</TextInput>
